<template>
  <Badge
    v-if="shouldShowLabel && tourTypeConfig"
    :variant="tourTypeConfig.color"
    :icon="tourTypeConfig.icon"
    :label="tourTypeConfig.label"
    size="small"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { type IconName, Badge, BadgeVariant } from '@tallo/design-system';

import { TourType } from '../interfaces/tour-type.enum';

interface TourTypeLabelProps {
  tourType: TourType;
}

interface TourTypeConfig {
  label: string;
  icon: IconName;
  color: BadgeVariant;
}

const props = defineProps<TourTypeLabelProps>();

const tourTypeConfigs: Partial<Record<TourType, TourTypeConfig>> = {
  [TourType.VIRTUAL]: {
    label: 'Virtual tour',
    icon: 'video-recorder',
    color: 'orange',
  },
  // Matches the badge showing-request-card renders, so the same tour reads the same on both screens.
  [TourType.SELF_GUIDED]: {
    label: 'Self-guided tour',
    icon: 'key',
    color: 'violet',
  },
};

const shouldShowLabel = computed(() => {
  // Only show label for tour types that have configuration (excludes IN_PERSON)
  return props.tourType in tourTypeConfigs;
});

const tourTypeConfig = computed(() => {
  return tourTypeConfigs[props.tourType as keyof typeof tourTypeConfigs];
});
</script>

<style scoped lang="scss"></style>
